// 입력값이 기본값과 얼마나 비슷한지 판단한다. 95% 이상이면 "아직 기본값 그대로"로 표시한다.
const SIMILARITY_THRESHOLD = 0.95;
const MAX_COMPARE_LENGTH = 2000;

function normalize(value: string): string {
  return value.replace(/\s+/g, " ").trim();
}

function levenshtein(left: string, right: string): number {
  if (left === right) return 0;
  if (!left.length) return right.length;
  if (!right.length) return left.length;
  let previous = Array.from({ length: right.length + 1 }, (_, index) => index);
  const current = new Array<number>(right.length + 1);
  for (let i = 1; i <= left.length; i += 1) {
    current[0] = i;
    for (let j = 1; j <= right.length; j += 1) {
      const cost = left[i - 1] === right[j - 1] ? 0 : 1;
      current[j] = Math.min(current[j - 1] + 1, previous[j] + 1, previous[j - 1] + cost);
    }
    previous = current.slice();
  }
  return previous[right.length];
}

export function defaultSimilarity(value: string, defaultValue: string): number {
  const normalizedValue = normalize(value).slice(0, MAX_COMPARE_LENGTH);
  const normalizedDefault = normalize(defaultValue).slice(0, MAX_COMPARE_LENGTH);
  if (!normalizedDefault || !normalizedValue) return 0;
  if (normalizedValue === normalizedDefault) return 1;
  const maxLength = Math.max(normalizedValue.length, normalizedDefault.length);
  if (Math.abs(normalizedValue.length - normalizedDefault.length) / maxLength > 1 - SIMILARITY_THRESHOLD) return 0;
  return 1 - levenshtein(normalizedValue, normalizedDefault) / maxLength;
}

export function isDefaultLikeValue(value: unknown, defaultValue: unknown): boolean {
  if (typeof defaultValue === "boolean" || typeof value === "boolean") return false;
  const valueText = value === undefined || value === null ? "" : String(value);
  const defaultText = defaultValue === undefined || defaultValue === null ? "" : String(defaultValue);
  if (!valueText.trim() || !defaultText.trim()) return false;
  return defaultSimilarity(valueText, defaultText) >= SIMILARITY_THRESHOLD;
}
